import React from "react";
import EffBadge from "@/components/EffBadge";
import { fmtNum } from "@/components/KpiCard";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Trash2 } from "lucide-react";

const TYPE_LABELS = { machine: "Makine", manual: "Manuel", team: "Ekip" };
const HEADERS = ["Tarih", "Tip", "Bölüm", "Makine/Kaynak", "Ürün", "Mesai", "Plan", "Standart", "Gerçek", "Verimlilik", ""];

export function EntriesTable({ entries, sel, meta, isAdmin, rangeInput, setRangeInput, isFiltered,
  onApplyFilter, onClearFilter, onToggle, onToggleAll, onRemove, onRemoveSelected, onRemoveAll }) {
  const name = (list, code) => meta[list]?.find((x) => x.code === code)?.name || code || "-";

  return (
    <Card className="bg-card border-border overflow-hidden" data-testid="recent-entries-card">
      <div className="px-4 pt-4 flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-lg font-medium">Üretim Kayıtları ({entries.length})</h3>
        <div className="flex flex-wrap items-center gap-2">
          <Input type="date" value={rangeInput.start} className="h-8 w-36 text-xs" data-testid="entries-filter-start"
            onChange={(e) => setRangeInput((r) => ({ ...r, start: e.target.value }))} />
          <span className="text-muted-foreground text-xs">—</span>
          <Input type="date" value={rangeInput.end} className="h-8 w-36 text-xs" data-testid="entries-filter-end"
            onChange={(e) => setRangeInput((r) => ({ ...r, end: e.target.value }))} />
          <Button variant="outline" size="sm" className="h-8 text-xs" data-testid="entries-filter-apply"
            onClick={onApplyFilter}>Filtrele</Button>
          {isFiltered && (
            <Button variant="ghost" size="sm" className="h-8 text-xs" data-testid="entries-filter-clear"
              onClick={onClearFilter}>Temizle</Button>
          )}
          <Button variant="destructive" size="sm" className="h-8 text-xs" data-testid="entries-delete-selected"
            onClick={onRemoveSelected} disabled={!sel.length}>
            <Trash2 size={13} className="mr-1" /> Seçilenleri Sil ({sel.length})
          </Button>
          {isAdmin && (
            <Button variant="outline" size="sm" className="h-8 text-xs border-destructive/50 text-destructive hover:bg-destructive/10"
              data-testid="entries-delete-all" onClick={onRemoveAll}>
              Tümünü Sil
            </Button>
          )}
        </div>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="border-border">
            <TableHead className="w-10">
              <Checkbox checked={entries.length > 0 && sel.length === entries.length} onCheckedChange={onToggleAll}
                data-testid="entries-select-all" className="border-border" />
            </TableHead>
            {HEADERS.map((h) => (
              <TableHead key={h} className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{h}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {entries.map((e) => (
            <TableRow key={e.id} className="border-border" data-testid={`entry-row-${e.id}`}>
              <TableCell className="py-2">
                <Checkbox checked={sel.includes(e.id)} onCheckedChange={() => onToggle(e.id)}
                  data-testid={`entry-select-${e.id}`} className="border-border" />
              </TableCell>
              <TableCell className="text-sm py-2 font-mono">{e.date}</TableCell>
              <TableCell className="text-sm py-2">{TYPE_LABELS[e.entry_type]}</TableCell>
              <TableCell className="text-sm py-2">{name("departments", e.department_code)}</TableCell>
              <TableCell className="text-sm py-2">{e.machine_code || name("employees", e.employee_code) || e.team_name || "-"}</TableCell>
              <TableCell className="text-sm py-2">{e.product_code || "-"}</TableCell>
              <TableCell className="text-xs py-2 text-muted-foreground">{e.mesai_type || e.shift || "-"}</TableCell>
              <TableCell className="text-sm py-2 font-mono text-right">{fmtNum(e.plan)}</TableCell>
              <TableCell className="text-sm py-2 font-mono text-right">{fmtNum(e.standard_capacity)}</TableCell>
              <TableCell className="text-sm py-2 font-mono text-right">{fmtNum(e.actual)}</TableCell>
              <TableCell className="text-sm py-2 text-right"><EffBadge value={e.efficiency} testid={`entry-eff-${e.id}`} /></TableCell>
              <TableCell className="py-2 text-right">
                <Button variant="ghost" size="icon" className="h-7 w-7 text-destructive" data-testid={`entry-delete-${e.id}`} onClick={() => onRemove(e.id)}>
                  <Trash2 size={13} />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
